<template>
  <Menu theme="light" active-name="1" class="webcast-detail-menu">
    <MenuGroup title="Livecast Settings">
      <MenuItem name="11" class="router-item">
        <router-link :to="'/wc/'+wc._id+'/settings'">Info & Settings</router-link>
      </MenuItem>
      <MenuItem name="12" class="router-item">
        <router-link :to="'/wc/'+wc._id+'/streams'">Stream Settings</router-link>
      </MenuItem>
      <MenuItem name="13" class="router-item">
        <router-link :to="'/wc/'+wc._id+'/widgets'">Widgets</router-link>
      </MenuItem>
      <MenuItem name="14" class="router-item">
        <router-link :to="'/wc/'+wc._id+'/embed-and-links'">Embed & Links</router-link>
      </MenuItem>
    </MenuGroup>
    <MenuGroup title="Page Management">
      <MenuItem name="21" class="router-item">
        <router-link :to="'/wc/'+wc._id+'/page-settings'">Page Settings</router-link>
      </MenuItem>
      <MenuItem name="22" class="router-item">
        <router-link :to="'/wc/'+wc._id+'/page-security'">Page Security</router-link>
      </MenuItem>
      <MenuItem name="23">
        <router-link :to="'/wc/'+wc._id+'/landing-page'" class="router-item">Landing Page</router-link>
      </MenuItem>
      <MenuItem name="24" class="router-item">
        <router-link :to="'/wc/'+wc._id+'/registration-form-management'">Registration Form</router-link>
      </MenuItem>
      <MenuItem name="25" class="router-item">
        <router-link :to="'/wc/'+wc._id+'/emails'">Emails</router-link>
      </MenuItem>
    </MenuGroup>
    <MenuGroup title="Management">
      <MenuItem name="31" class="router-item">
        <router-link :to="'/wc/'+wc._id+'/control_room'">Control Room</router-link>
      </MenuItem>
      <MenuItem name="32" class="router-item">
        <router-link :to="'/wc/'+wc._id+'/qna'">Q&A Moderation</router-link>
      </MenuItem>
      <MenuItem name="33" class="router-item">
        <router-link
          :to="'/publisher/'+wc._id"
          v-if="$store.state.auth.user.role=='admin'"
        >Publisher</router-link>
      </MenuItem>
      <MenuItem name="34" class="router-item">
        <router-link
          :to="'/audioRoom/'+wc._id"
          v-if="$store.state.auth.user.role=='admin'"
        >Audio Room</router-link>
      </MenuItem>
    </MenuGroup>
    <MenuGroup title="Reporting">
      <MenuItem name="41" class="router-item">
        <router-link :to="'/wc/'+wc._id+'/report_dashboard'">Realtime Dashboard</router-link>
      </MenuItem>
      <MenuItem name="42" class="router-item">
        <router-link :to="'/wc/'+wc._id+'/who_is_watching'">Who Is Watching</router-link>
      </MenuItem>
      <MenuItem name="43" class="router-item">
        <router-link :to="'/wc/'+wc._id+'/summary_report'">Event Summary Report</router-link>
      </MenuItem>
      <MenuItem name="44" class="router-item">
        <router-link :to="'/wc/'+wc._id+'/registrations_report'">Registrations</router-link>
      </MenuItem>
      <MenuItem name="45" class="router-item">
        <router-link :to="'/wc/'+wc._id+'/attendee_report'">Attendees</router-link>
      </MenuItem>
      <MenuItem name="45" class="router-item">
        <router-link :to="'/wc/'+wc._id+'/audio_participants'">Audio Participants</router-link>
      </MenuItem>
    </MenuGroup>
  </Menu>
</template>

<style lang="scss">
.webcast-detail-menu {
  padding-bottom: 100px !important;
  .ivu-menu-item {
    a {
      display: block;
      padding: 10px 24px;
      color: #495060;
    }
  }

  &.ivu-menu-vertical {
    .router-item {
      padding: 0;
    }
  }
}
</style>

<script>
export default {
  data() {
    return {
      wc: undefined
    };
  },
  created() {
    this.$set(this.$data, "wc", this.$store.state.webcast.copy);
  }
};
</script>

<style>
</style>
